import { cn } from "cn";

type LogomarkProps = {
  className?: string;
};

export function Logomark({ className }: LogomarkProps) {
  return (
    <span
      className={cn(
        "relative inline-flex size-7 shrink-0 items-center justify-center overflow-hidden rounded-lg text-gray-1",
        "bg-gray-12",
        "shadow-[inset_0_1px_0_rgb(255_255_255/0.18),0_1px_2px_rgb(0_0_0/0.2)]",
        className,
      )}
      aria-label="Teral"
    >
      <svg
        viewBox="0 0 360 117"
        fill="currentColor"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        className="size-[19px] drop-shadow-[0_1px_0_rgb(0_0_0/0.15)]"
      >
        <title>Teral</title>

        <g transform="translate(-550.899108 -335.342065)">
          <g transform="translate(268.491583 159)">
            <g>
              <g transform="matrix(0 0.620219 -0.620219 0 790.365697 17.753513)">
                <g transform="matrix(-1 0 0 -0.859424 783.304318 949.503978)">
                  <path d="M340 460.197L433.803 554H340V460.197Z" strokeWidth="1.73" />
                </g>
                <g transform="matrix(1 0 0 0.859424 9.501068 -2.737443)">
                  <path d="M340 460.197L433.803 554H340V460.197Z" strokeWidth="1.73" />
                </g>
                <g transform="matrix(1 0 0 0.859424 -84.302182 -83.354176)">
                  <path d="M340 460.197L433.803 554H340V460.197Z" strokeWidth="1.73" />
                </g>
                <g transform="matrix(-1 0 0 -0.859424 689.501068 868.887245)">
                  <path d="M340 460.197L433.803 554H340V460.197Z" strokeWidth="1.73" />
                </g>
              </g>

              <g transform="matrix(-1 0 0 -1 779.172098 469.041178)">
                <g transform="matrix(0 -1.10726 1.10726 0 213.389946 814.910575)">
                  <g transform="matrix(0.560138 0 0 0.481396 281.177866 -101.082192)">
                    <path d="M340 460.197L433.803 554H340V460.197Z" strokeWidth="1.73" />
                  </g>

                  <g transform="matrix(0 -1 1 0 351.170171 584.693127)">
                    <g transform="matrix(-0.560138 0 0 -0.481396 662.071701 387.147911)">
                      <path d="M340 460.197L433.803 554H340V460.197Z" strokeWidth="1.73" />
                    </g>
                    <g transform="matrix(0.560138 0 0 0.481396 281.177866 -101.082192)">
                      <path d="M340 460.197L433.803 554H340V460.197Z" strokeWidth="1.73" />
                    </g>
                  </g>
                </g>

                <g transform="matrix(0 1.10726 -1.10726 0 580.139199 -287.690874)">
                  <g transform="matrix(0.560138 0 0 -0.560138 397.553083 430.77106)">
                    <g transform="matrix(-1 0 0 0.859424 472.238309 77.879289)">
                      <path d="M340 460.197L433.803 554H340V460.197Z" strokeWidth="1.73" />
                    </g>
                    <g transform="matrix(1 0 0 -0.859424 -301.564941 1030.120711)">
                      <path d="M340 460.197L433.803 554H340V460.197Z" strokeWidth="1.73" />
                    </g>
                  </g>

                  <g transform="matrix(0.560138 0 0 0.481396 281.177866 -101.082192)">
                    <path d="M340 460.197L433.803 554H340V460.197Z" strokeWidth="1.73" />
                  </g>
                </g>
              </g>
            </g>

            <g>
              <g transform="matrix(0.894616 0 0 0.894616 88.96039 129.041181)">
                <circle cx="592.773" cy="145.85" r="25.15" strokeWidth="1.12" />
              </g>
              <g transform="matrix(0.894616 0 0 0.894616 88.96039 79.041181)">
                <circle cx="592.773" cy="145.85" r="25.15" strokeWidth="1.12" />
              </g>
              <g transform="matrix(0.894616 0 0 0.894616 88.96039 79.041181)">
                <circle cx="592.773" cy="145.85" r="25.15" strokeWidth="1.12" />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </span>
  );
}
